import React from 'react';
import './index.css';
import './styles/tailwind.css';
import { createRoot } from 'react-dom/client';
import isoWeek from 'dayjs/plugin/isoWeek';
import duration from 'dayjs/plugin/duration';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import 'dayjs/locale/da';
import 'dayjs/locale/sv';
import 'dayjs/locale/nb';
import 'dayjs/locale/fi';

import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from './sentry';
import './transifex';
import { RouterProvider } from './context/routing';
import { readCachedBrandColor } from './app/brandColorCache';
import { App } from './app';

dayjs.extend(isoWeek);
dayjs.extend(duration);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);

if (window.WH_SS_INIT_ROUTE) {
  window.usingAsEmbedded = true;
}

// Paint the loading spinner in the tenant's brand color from the very first
// frame. The company API hasn't responded yet at this point, so we use the
// color cached on a previous load (Theme.store persists it). Falls back to the
// --spinner-color default (navy) in tokens.css when there's no cache.
const cachedBrandColor = readCachedBrandColor();
if (cachedBrandColor) {
  document.documentElement.style.setProperty(
    '--spinner-color',
    cachedBrandColor
  );
}

const root = createRoot(
  document.getElementById(window.WH_SS_ROOT_ELEMENT_ID || 'root')!
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <RouterProvider>
          <App />
        </RouterProvider>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
